import { useEffect, useState } from 'react';
import type { OutboxItem } from './db';
import { onOutboxChange, pendingItems } from './outbox';

export function useOutbox(kind?: OutboxItem['kind']) {
  const [items, setItems] = useState<OutboxItem[]>([]);
  useEffect(() => {
    let alive = true;
    const load = () => pendingItems().then((all) => alive && setItems(all.filter((i) => !kind || i.kind === kind)));
    load();
    const off = onOutboxChange(load);
    return () => {
      alive = false;
      off();
    };
  }, [kind]);
  return items;
}

export function useOnline() {
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}
